"use strict";

exports.__esModule = true;
exports.isPrerenderMode = exports.isFormFactorTouch = exports.isFormFactorDesktop = exports.isFormFactorTablet = exports.isFormFactorMobile = exports.isSEOMode = exports.isPreviewMode = exports.isEditMode = exports.isSiteMode = exports.viewModeWrapper = void 0;

var _viewMode = _interopRequireDefault(require("../constants/viewMode"));

var _formFactor = _interopRequireDefault(require("../constants/formFactor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ViewModeWrapper = /*#__PURE__*/function () {
  function ViewModeWrapper() {
    this.setViewMode = this.setViewMode.bind(this);
    this.isSiteMode = this.isSiteMode.bind(this);
    this.isEditMode = this.isEditMode.bind(this);
    this.isPrerenderMode = this.isPrerenderMode.bind(this);
    this.isPreviewMode = this.isPreviewMode.bind(this);
    this.isSEOMode = this.isSEOMode.bind(this);
    this.setFormFactor = this.setFormFactor.bind(this);
    this.isFormFactorDesktop = this.isFormFactorDesktop.bind(this);
    this.isFormFactorMobile = this.isFormFactorMobile.bind(this);
    this.isFormFactorTablet = this.isFormFactorTablet.bind(this);
    this.isFormFactorTouch = this.isFormFactorTouch.bind(this);
    this._viewMode = _viewMode["default"].SITE;
    this._formFactor = _formFactor["default"].DESKTOP;
  }

  var _proto = ViewModeWrapper.prototype;

  _proto.setViewMode = function setViewMode(viewMode) {
    this._viewMode = viewMode;
  };

  _proto.setFormFactor = function setFormFactor(forceVal) {
    this._formFactor = forceVal;
  };

  _proto.isFormFactorMobile = function isFormFactorMobile() {
    return this._formFactor === _formFactor["default"].MOBILE;
  };

  _proto.isFormFactorTablet = function isFormFactorTablet() {
    return this._formFactor === _formFactor["default"].TABLET;
  };

  _proto.isFormFactorDesktop = function isFormFactorDesktop() {
    return this._formFactor === _formFactor["default"].DESKTOP;
  };

  _proto.isFormFactorTouch = function isFormFactorTouch() {
    return this.isMobile() || this.isTablet();
  };

  _proto.isSiteMode = function isSiteMode() {
    return this._viewMode === _viewMode["default"].SITE;
  };

  _proto.isEditMode = function isEditMode() {
    return this._viewMode === _viewMode["default"].EDIT;
  };

  _proto.isPreviewMode = function isPreviewMode() {
    return this._viewMode === _viewMode["default"].PREVIEW;
  };

  _proto.isPrerenderMode = function isPrerenderMode() {
    return this._viewMode === _viewMode["default"].PRERENDER;
  };

  _proto.isSEOMode = function isSEOMode() {
    return this._viewMode === _viewMode["default"].SEO;
  };

  return ViewModeWrapper;
}();

var viewModeWrapper = new ViewModeWrapper();
exports.viewModeWrapper = viewModeWrapper;
var isSiteMode = viewModeWrapper.isSiteMode;
exports.isSiteMode = isSiteMode;
var isEditMode = viewModeWrapper.isEditMode;
exports.isEditMode = isEditMode;
var isPreviewMode = viewModeWrapper.isPreviewMode;
exports.isPreviewMode = isPreviewMode;
var isSEOMode = viewModeWrapper.isSEOMode;
exports.isSEOMode = isSEOMode;
var isFormFactorMobile = viewModeWrapper.isFormFactorMobile;
exports.isFormFactorMobile = isFormFactorMobile;
var isFormFactorTablet = viewModeWrapper.isFormFactorTablet;
exports.isFormFactorTablet = isFormFactorTablet;
var isFormFactorDesktop = viewModeWrapper.isFormFactorDesktop;
exports.isFormFactorDesktop = isFormFactorDesktop;
var isFormFactorTouch = viewModeWrapper.isFormFactorTouch;
exports.isFormFactorTouch = isFormFactorTouch;
var isPrerenderMode = viewModeWrapper.isPrerenderMode;
exports.isPrerenderMode = isPrerenderMode;